import type { StatementName } from '@/hooks/useCompanyStatementsAPIFormatted/types';

export const HEALTH_STATEMENTS_DEFAULT: StatementName[] = [
  'AreShortTermLiabilitiesCovered',
  'AreLongTermLiabilitiesCovered',
  'IsDebtLevelAppropriate',
  'HasDebtReducedOverTime',
  'IsDebtCoveredByCashflow',
  'IsInterestCoveredByProfit',
];
export const HEALTH_STATEMENTS_FINANCIAL: StatementName[] = [
  'HasAnAppropriateLevelOfAssets',
  'HasAppropriateBadLoanAllowance',
  'HasPrimarilyLowRiskFunding',
  'HasAppropriateLoanLevel',
  'HasPrimarilyDepositFunding',
  'HasAppropriateNonPerformingLoans',
];
export const HEALTH_STATEMENTS_LOSS_MAKING: StatementName[] = [
  'AreShortTermLiabilitiesCovered',
  'AreLongTermLiabilitiesCovered',
  'IsDebtLevelAppropriate',
  'HasDebtReducedOverTime',
  'HasCashRunwayIfStable',
  'HasCashRunwayIfGrowing',
];
